module.exports = ['curriculumManager', '$location', 'odetManager', 'settings', '$notification', 'messages', '$transitions', '$document', 'kovSentry', '$rootScope',
  function (curriculumManager, $location, odetManager, settings, $notification, messages, $transitions, $document, kovSentry, $rootScope) {
    'use strict';

    // Load curricula based on url params
    var params = $location.$$search;
    curriculumManager.prepareCurriculum(params.version, params.date, settings.apisAndUrls.cachedApi, settings.anValuesThemeRoot);
    odetManager.prepareCurriculum(settings.apisAndUrls.cachedApi);

    console.time('Get Curriculum');
    kovSentry.startLog('Get Curriculum');

    curriculumManager.getCurriculum().then(function (curriculum) {
      // Tell prerender.io when website is done loading
      window.prerenderReady = true;

      kovSentry.endLog('Get Curriculum');
      console.timeEnd('Get Curriculum');

      console.log('### Curriculum version: ' + curriculum.title + ' ###');
    }, function () {
      $notification.error(messages.fetch.curriculum);
    });

    var locationSearch;

    $transitions.onBefore({}, function ($transition) {
      // save location.search so we can add it back after transition is done
      locationSearch = $location.search();
    });

    $transitions.onStart({}, function ($transition) {
      // We save the name of the previous component so we can handle certain cases (see in bib controllers)
      $rootScope.previousState = $transition.from().name;
    });

    $transitions.onSuccess({}, function ($transition) {
      // restore all query string parameters back to $location.search
      const current = $location.search();
      if (locationSearch.preview) {
        current.preview = locationSearch.preview;
      }
      if (locationSearch.version) {
        current.version = locationSearch.version;
      }
      if (locationSearch.date) {
        current.date = locationSearch.date;
      }
      $location.search(current);

      if (settings.googlAnalytics.enabled) {
        window.gtag('event', 'page_view', {
          page_title: $document[0].title,
          page_location: $location.path()
        });
      }
    });
  }];



// WEBPACK FOOTER //
// ./web/js/app/initialize.js